import type { AppState, MutationClass } from '../../../models'
import type { StorageService } from '../../../services'

import { CONTAINER } from '../../../config'

import { TYPES } from '../../../config/inversify.types'

import { APP_CONSTS } from '../app.consts'

export class SetAlreadyLoggedInOnceMutation implements MutationClass {
  static execute(this: void, state: AppState, alreadyLoggedInOnce: boolean): void {
    const storageService: StorageService = CONTAINER.get<StorageService>(TYPES.StorageService)
    storageService.setItem(APP_CONSTS.storage.alreadyLoggedInOnce, alreadyLoggedInOnce.toString())
    state.alreadyLoggedInOnce = alreadyLoggedInOnce
  }
}
